import { render, staticRenderFns } from "./CategoryItemListSorter.vue?vue&type=template&id=1c309c36&scoped=true&"
import script from "./CategoryItemListSorter.vue?vue&type=script&lang=ts&"
export * from "./CategoryItemListSorter.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryItemListSorter.vue?vue&type=style&index=0&id=1c309c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c309c36",
  null
  
)

export default component.exports